module.exports = "/images/vendor/flag-icon-css/flags/4x3/gp.svg?fa4cab3e4ee1b865a975e5eb6ab70d03";